import { ChildById } from "../ComponentRenderer";
import { ComponentProps } from "../registry";
import { resolveChildRef } from "../../path";
import { ChildRef } from "../../types";

export function Card({ fields, scope }: ComponentProps) {
  const childId = resolveChildRef(fields.child as ChildRef);
  return (
    <div className="a2-card">
      <ChildById id={childId} scope={scope} />
    </div>
  );
}
